import { z } from "zod";

export const OAuthConsentRequestInfoSchema = z.object({
  clientName: z.string().nullable(),
  redirectUri: z.string(),
  /** What the client asked for, verbatim; may exceed what the user can grant */
  scopes: z.array(z.string()),
  /** What the consenting user can actually grant: requested ∩ role-grantable */
  grantableScopes: z.array(z.string()),
  projectName: z.string().nullable(),
  state: z.string().nullable(),
});

export type OAuthConsentRequestInfo = z.infer<
  typeof OAuthConsentRequestInfoSchema
>;

export const OAuthConsentApproveRequestSchema = z.object({
  /** The scopes the user selected; when omitted, the whole grantable set is granted */
  scopes: z.array(z.string()).optional(),
});

export type OAuthConsentApproveRequest = z.infer<
  typeof OAuthConsentApproveRequestSchema
>;

export const OAuthConsentApprovalSchema = z.object({
  redirectUri: z.string(),
  code: z.string(),
  state: z.string().nullable(),
});

export type OAuthConsentApproval = z.infer<typeof OAuthConsentApprovalSchema>;

export const OAuthMintInputSchema = z.object({
  clientId: z.string(),
  authUserId: z.string(),
  organizationIds: z.array(z.string()),
  scopes: z.array(z.string()),
  resource: z.string().optional(),
});

export type OAuthMintInput = z.infer<typeof OAuthMintInputSchema>;

export const OAuthTokenInfoSchema = z.object({
  authUserId: z.string(),
  organizationIds: z.array(z.string()),
  scopes: z.array(z.string()),
  clientId: z.string(),
  expiresAt: z.date(),
  resource: z.string().nullable(),
});

export type OAuthTokenInfo = z.infer<typeof OAuthTokenInfoSchema>;
